import React, {useState, useEffect, useRef} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {config, selectStyles, DatabaseName, API_URL, Token, ServerUrl} from '../component/include'
import Select from 'react-select'
import { formatGroupLabel} from '../component/globalFunction'

import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const StudentAdmission =()=>{
	const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });
    
    const [allFamily, setAllFamily]= useState([])
	const schoolInfo  = useSelector(state => state.rootReducer.schoolInfo);	
const schoolClass  = useSelector(state => state.rootReducer.schoolClass);

		const [CurrentSession, setCurrentSession] = useState('')
	const Initials = 
        { 
			code:'st'+Math.random().toString(36).substring(2,9),
			currentSession:CurrentSession&&CurrentSession,
			classID:'',
			studentClass:[],
			gender:'',
			feecharge:'',
			studentName:'',
			remark:'',
			totalFee:0,
			regDate: '',
			motherName:'',
			transportFee:'',
			distanceSelect:'',
			 fatherName:'',
			 admissionNumber:'',
			  registerNumber:'',
			   emailAddress:'',
				mobile:'',
				religion:'',
				dateOfBirth:'',
				 feeCharge:'',
				 tribe:'',
				 transportFeeSelect:'',
				 feeStructure:[],
				 learningType:[],
				 family_name:{label:'', value:''}	 
		}
		
    const [errors, setErrors] = useState({});
     
	const [admission, setAdmission] = useState(Initials);
	
		const  getTotal= async()=>{

			var sql ="select AUTO_INCREMENT as total from information_schema.TABLES where TABLE_SCHEMA ='"+DatabaseName+"' and TABLE_NAME ='tbl_students'"

			const fd = new FormData();
			fd.append("sql", sql);
			
			fd.append('jwt', Token);
			let url = ServerUrl+'/fetchBySql_controller';
			
		await	axios.post(url, fd, config)
			.then(result => {
				if(result.data.length!==0){

					let total =  Number(result.data[0].total)+1
					setAdmission({...admission, total:total, registerNumber:('000'+total).slice(-4)})
			}
			})
			.catch((error)=>{
				//Alerts('Error!', 'danger', JSON.stringify(error.message)) 
			})
			}

		
			const handleSession =()=>{
				let url = API_URL+'/session/all';
				axios.get(url, config).then(result=>{
					if(result.data.data.length!==0){
						let data = result.data.data.filter(item=>item.status==='Active')
						setCurrentSession(data[0].startYear)
					}
				})
				.catch((error)=>{
					Alerts('Error!', 'danger', error.message)
				})  
			}

	
	const handleChange = event =>{
		const {name, value} = event.target
	   setAdmission({...admission, [name] : value });
	   setErrors({...errors, [name]:''})
	}
	
	const handleSelect = (option, action)=>{
		setAdmission({...admission, [action.name]: option});
		setErrors({...errors, [action.name]:''})
	}


	const handleSelectClass = (option, action)=>{


   var pattern = schoolInfo&&schoolInfo[0].admissionNumberPattern || ''
   var shortYear = new Date().toLocaleDateString('en', {year: '2-digit'})
   let newPattern = pattern&&pattern.replace('{schoolAbbreviation}', schoolInfo&&schoolInfo[0].schoolAbbreviation);
	let pat = newPattern&&newPattern.replace('{AdmissionYear}', shortYear);
	
	let admissionNo = pat&&pat.replace('{AdmissionNumber}', ('000'+admission.total).slice(-4));
		setAdmission({...admission, [action.name]: option, currentSession:CurrentSession, admissionNumber:admissionNo});
		setErrors({...errors, [action.name]:''})

	}


	const handleSubmit = event =>{
		event.preventDefault();
		var errormessage = [];

		if(!admission.admissionNumber){
			let msg ='Unable to generate admission number, pls try again';
			setErrors({...errors, studentClass:msg})
			errormessage.push(msg);
		} 
	
		if(admission.studentClass.length===0){
			let msg  ='Please select admission class';
			setErrors({...errors, studentClass:msg})
			errormessage.push(msg);
		}

		if(admission.gender.length===0){
			let msg  ='Please select gender';
			setErrors({...errors, gender:msg})
			errormessage.push(msg);
		}

		
		if(admission.learningType.length===0){
			let msg  ='Please select learning type';
			setErrors({...errors, learningType:msg})
			errormessage.push(msg);
		}

		if (errormessage.length<=0) {
			submit()
		}

	} 
	

const submit =()=>{  
	let formData = admission; 

      const fd = new FormData(); 
    for(let k in formData){
        fd.append(k,formData[k]);
	}; 

	window.scrollTo(0,0);
	fd.append('familyName', admission.family_name.value);
	fd.append('sectionID', admission.studentClass.value);
	fd.append('selectedGender', admission.gender.value);
	fd.append('classID', admission.studentClass.classID);
	fd.append('learningType', admission.learningType.value)

 setNotice({...notice,  isLoading: true}) 
	   let url = API_URL+'/student/add';
	  axios.post(url, fd, config)
	  .then(response =>{
		if (response.data.status ===200){
			setErrors({...errors, successMessage: response.data.message})
			
			setTimeout(() => {
				window.location.reload()
			}, 3000);
		} else{
			setErrors({...errors, errorMessage: response.data.message})
	}  
	})
	.catch((error)=>{
		setErrors({...errors, errorMessage: JSON.stringify(error.message)}) 
	})
	.finally(()=>{
	  setNotice({...notice, isLoading: false}) 
	 
	})  
}





const fetchFamily =()=>{
let url = API_URL + '/fetch/data/tbl_family'
	axios.get(url, config).then(result=>setAllFamily(result.data.data))
}
		

	

		useEffect(()=>{
			getTotal()
			handleSession()
			fetchFamily()
		},[]);
		
        return ( <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                
                   {/* <!-- Page-header start --> */}
        <PageHeader title="Student Admission">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-graduation-cap"></i> </a>
                            </li>
							
                        <li className="breadcrumb-item"><Link to="/students/view_students"> Students</Link></li>  
                    <li className="breadcrumb-item"><a href="#!">Student Admission</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">
                <div className="row  ">

								<div className="col-sm-12">
								{errors.errorMessage?
<div className="alert alert-danger background-danger">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.errorMessage}</strong> 
    </div>:''}

	{errors.successMessage?
<div className="alert alert-success background-success">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.successMessage}</strong> 
    </div>:''}
	
	<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Register New Student</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		
		<div className="card-block">
		<div className="card z-depth-0">
			<div className="card-block">

				<form method='post' autoComplete="off" onSubmit={handleSubmit}>
		<fieldset>
			
			<div className="row">
		
		<section className="col-md-6">
			
						

									

											<div className="form-group">
				<label > Admission Class <span style={{color:'red'}}>*</span></label>
				<Select  options={
                            schoolClass.map((list, idx)=> {
                               return {key:idx, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                   return sec.sname !==''? {key:id, classID:list.ID, isSection:'1', value: sec.ID, label: sec.sname}:{classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                               }) }
							 })
							 
                        } 
						style={selectStyles}
                        formatGroupLabel={formatGroupLabel}
onChange={handleSelectClass} className={errors.studentClass ? 'form-control form-control-danger' : ''} name="studentClass" value={admission.studentClass}  /> <span style={{color:'red'}}>{errors.studentClass && errors.studentClass}</span>
										
									</div>


									<div className="form-group">
						<label >Admission Number <span style={{color:'red'}}>*</span></label>

						<input type='text' id="admissionNumber" autoComplete="off" name="admissionNumber" required  value={admission.admissionNumber}   className={errors.admissionNumber ? 'form-control form-control-danger' : 'form-control'}  onChange={handleChange} placeholder="Admission Number" />
						<span style={{color:'red'}}>{errors.admissionNumber && errors.admissionNumber}</span>	
											</div>


											<div className="form-group">
			<label >Student Name<span style={{color:'red'}}>*</span></label>
				
        <input type='text' id="studentName" autoComplete="off" name="studentName" required  value={admission.studentName}  className={errors.studentName  ? 'form-control form-control-danger' : 'form-control'}  onChange={handleChange} placeholder="Student Name" />

		</div>

				
		<div className="form-group">
			<label >Date of Admission<span style={{color:'red'}}>*</span></label>
		
        <input type='date' id="regDate" autoComplete="off" name="regDate" required value={admission.regDate}  className={errors.regDate  ? 'form-control form-control-danger' : 'form-control'}  onChange={handleChange} placeholder="Date of Admission" />

		</div>

		

<div className="form-group">
			<label >Email Address</label>
		
			
        <input type='email' id="emailAddress" autoComplete="off" name="emailAddress"  value={admission.emailAddress}  className={errors.emailAddress  ? 'form-control form-control-danger' : 'form-control'}  onChange={handleChange} placeholder="Student Email Address" />

		</div>

		<div className="form-group">
			<label >Date of Birth <span style={{color:'red'}}>*</span></label>
			
        <input type='date' id='dateOfBirth' autoComplete="off" name='dateOfBirth' required value={admission.dateOfBirth} className="form-control" onChange={handleChange} placeholder='Date of Birth' />
		</div>
			

		<div className="form-group">
			<label >Student Mobile</label>
			
        <input type='text' id='mobile' autoComplete="off" name='mobile' value={admission.mobile} className="form-control" onChange={(e)=>setAdmission({...admission, mobile:e.target.value.slice(0,11)})} placeholder='Student Mobile' />
		</div>


			</section> 
				
				<section className="col-md-6">
				<div className="form-group">
						<label >Register Number </label>
						<input type="text" name="registerNumber" autoComplete="off" placeholder='Register number or file number ' onChange={handleChange} value={admission.registerNumber} className="form-control" />
												
											</div>
				
											<div className="form-group">
						<label >Tribe </label>
						<input type="text" name="tribe" autoComplete="off" placeholder='Student Tribe ' onChange={handleChange} value={admission.tribe} className="form-control" />
												
											</div>

					<div className="form-group">
						<label >Gender<span style={{color:'red'}}>*</span></label>
						<Select  options={[
                    { value: 'Male', label: 'Male' },
                    { value: 'Female', label: 'Female' },
                ]} 
onChange={handleSelect}  name="gender" value={admission.gender} className={errors.gender ? 'form-control form-control-danger' : ''} /> 
								<span style={{color:'red'}}>{errors.gender && errors.gender}</span>				
											</div>
							  
					
    
							<div className="form-group">
                        <label > Learning Type <span style={{color:'red'}}>*</span></label>
                        <Select  options={[
                    { value: 'Boarder', label: 'Boarder' },
                    { value: 'Day', label: 'Day' },
                ]} 
                        onChange={handleSelect}  name="learningType" value={admission.learningType} styles={selectStyles}  /> 
						
	<span style={{color:'red'}}>{errors.learningType && errors.learningType}</span>
             </div>  



					
											


<div className="form-group">
 <label >Select Family (Optional)</label>
 <Select   options={allFamily&&allFamily.map((list, idx)=> {
                                       return {key:idx, value: list.code, label:list.familyName}
                                     })
                                } 
onChange={handleSelect}  name="family_name" value={admission.family_name} styles={selectStyles} /> 
                         
                     </div>

		<div className="form-group">
						<label >Father Name</label>
						<input type="text" onChange={handleChange} autoComplete="off" value={admission.fatherName} name="fatherName" className="form-control" />
												
											</div>
											
								<div className="form-group">
						<label >Mother Name</label>
						<input type="text" name="motherName" autoComplete="off" onChange={handleChange} value={admission.motherName} className="form-control" />
												
											</div>
											
										</section>
										</div>
										
						</fieldset>
	<footer className="pull-right">
	<button type="submit"    className="btn btn-inverse ">Submit</button>
	
								</footer>	
								</form>	
								</div>	</div>		
							</div>
							</div>
							</div>
                 
                </div>


                </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(StudentAdmission) 